import { ReactNode } from "react";
import { useTokenInitializer } from "src/hooks";
import { useUrlParamsContext } from "src/contexts";
import { Loader } from "src/components";

interface RouteGuardProps {
  children: ReactNode;
}

const RouteGuard: React.FC<RouteGuardProps> = ({ children }) => {
  const { currencyId, paymentRouteId, apiUrl, storedDataKey } = useUrlParamsContext();
  const { accessToken } = useTokenInitializer(storedDataKey);

  const requiredUrlParamsPresent = currencyId && paymentRouteId && apiUrl;

  if (!requiredUrlParamsPresent || !accessToken) {
    return <Loader />;
  }

  return <>{children}</>;
};

export default RouteGuard;
